import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Checkbox } from '../../../../../components/checkbox/Checkbox';
import styles from './legislation_restrictor.module.scss';

type Props = {
  checked: boolean;
  onCheck: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
};

export function LegislationRestrictor({ checked, onCheck }: Props) {
  return (
    <div className={styles.restrict} onClick={onCheck}>
      <span className={styles.icon}>
        <Checkbox checked={checked} />
      </span>
      <FormattedMessage id="search/components/search-snippets/main/legislation/LegislationRestrictor.tsx/1" />
      <span className="hide_on--mobile">
        {'\u00A0'}
        <FormattedMessage id="search/components/search-snippets/main/legislation/LegislationRestrictor.tsx/2" />
      </span>
    </div>
  );
}
